function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPaperVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e6c9"
    },
    id: "OPT-paper_x5F_volume_x5F_0_x5F_24_1_",
    d: "M21.5,22h-19C2.2,22,2,21.8,2,21.5V9h1v12h18V9h1v12.5C22,21.8,21.8,22,21.5,22z  M13,8V3h-2v5H9l3,4l3-4H13z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperVolume);
export default __webpack_public_path__ + "static/media/img_PaperVolume.55c2c05de766eb7cbe1500ad51831494.svg";
export { ForwardRef as ReactComponent };